export default {
      id: "hamburger-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#hamburger-icon",
      toString: function () {
        return this.url;
      }
    }